import React from 'react';
import i18n from 'src/utils/translate';

export const Disclaimer = () => (
  <div className="medical-disclaimer">
    <p>
      {i18n.t('Content on HealthUnlocked does not replace the relationship between you and doctors or other healthcare professionals nor the advice you receive from them.')}
    </p>
    <p>
      {i18n.t('Never delay seeking advice or dialling emergency services because of something that you have read on HealthUnlocked.')}
    </p>
  </div>
);
